/** @jsx jsx */
import { jsx } from "theme-ui"
import { Component } from "react"
import PropTypes from "prop-types"

import Icon from "../assets/icon"
import NavigationSubmenu from "./navigation-submenu"
import Link from "./link"

import { colors } from "../theme"

class NavigationMainItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      shopSubNavigation: false,
      currentSub: props.currentSub,
      currentLanguage: props.currentLanguage,
      open: props.iconName === props.currentSub,
      seoLinks: props.seoLinks,
    }
    this.handleClick = this.handleClick.bind(this)
    this.toggleSubMenu = this.toggleSubMenu.bind(this)
  }

  handleClick() {
    this.toggleSubMenu()
  }

  toggleSubMenu() {
    let open = this.props.iconName === this.state.currentSub
    if (open) {
      this.props.openFn("")
    } else {
      this.props.openFn(this.props.iconName)
    }
  }

  static getDerivedStateFromProps(props, state) {
    return {
      currentSub: props.currentSub,
      open: props.iconName === props.currentSub,
    }
  }

  render() {
    let currentMenuPointStyles = this.props.active
      ? {
          backgroundColor: colors.background,
          "& path": {
            fill: colors.navigation[this.props.iconName],
            // fill: "navigation." + this.props.iconName
          },
          ":after": {
            display: "block",
            color: colors.navigation[this.props.iconName],
            // color: "navigation." + this.props.iconName,
            fontSize: 2,
            lineHeight: "8px",
            marginTop: "-5px",
            content: '"..."',
          },
        }
      : {}

    if (!this.props.active && this.state.open) {
      currentMenuPointStyles = {
        "& path": {
          fill: colors.navigation[this.props.iconName],
          // fill: "navigation." + this.props.iconName
        },
      }
    }

    let clickFn = this.state.open ? () => {} : this.handleClick

    let mainNavigationItem = (
      <div
        sx={{ variant: "navigation.mainItemBtn" }}
        className="main-navigation-item-button"
        onClick={clickFn}
        role="button"
        tabIndex="0"
        onKeyPress={clickFn}
      >
        <div
          sx={{
            variant: "navigation.iconContainer",
          }}
        >
          <Icon
            icon={this.props.iconName}
            style={{ variant: "navigation.icon" }}
          />
        </div>
        {this.props.displayName}
      </div>
    )

    if (
      this.state.open ||
      (this.props.extras &&
        this.props.extras.length === 0 &&
        this.props.navigationItems &&
        this.props.navigationItems.length === 0)
    ) {
      mainNavigationItem = (
        <Link
          to={this.props.url}
          language={this.state.currentLanguage}
          sx={{ textDecoration: "none", color: "inherit" }}
        >
          {mainNavigationItem}
        </Link>
      )
    }

    return (
      <div
        sx={{
          variant: "navigation.mainItem",
          "&:hover path": {
            fill: colors.navigation[this.props.iconName],
            // fill: "navigation." + this.props.iconName,
          },
          ...currentMenuPointStyles,
        }}
        className="main-navigation-item"
      >
        {mainNavigationItem}

        {this.state.open && (
          <NavigationSubmenu
            navigationItems={this.props.navigationItems}
            extras={this.props.extras}
            closeFn={this.toggleSubMenu}
            open={this.state.open}
            displayName={this.props.displayName}
            currentLanguage={this.state.currentLanguage}
            seoLinks={this.state.seoLinks}
            currentPage={this.props.currentPage}
            url={this.props.url}
            accentColor={colors.modes[this.props.iconName].accent}
            style={{
              backgroundColor: colors.modes[this.props.iconName].primary,
            }}
          />
        )}
      </div>
    )
  }
}

NavigationMainItem.defaultProps = {
  seoLinks: {},
}

NavigationMainItem.propTypes = {
  currentSub: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  openFn: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  displayName: PropTypes.string.isRequired,
  navigationItems: PropTypes.array,
  extras: PropTypes.array,
  currentLanguage: PropTypes.oneOf(["de", "en"]).isRequired,
  seoLinks: PropTypes.object.isRequired,
}

export default NavigationMainItem
